import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:24
* @route '/{locale}/tools/pdf/sign/page-count'
*/
export const pageCount = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

pageCount.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/sign/page-count',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:24
* @route '/{locale}/tools/pdf/sign/page-count'
*/
pageCount.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return pageCount.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:24
* @route '/{locale}/tools/pdf/sign/page-count'
*/
pageCount.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:24
* @route '/{locale}/tools/pdf/sign/page-count'
*/
const pageCountForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:24
* @route '/{locale}/tools/pdf/sign/page-count'
*/
pageCountForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

pageCount.form = pageCountForm

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::submit
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:50
* @route '/{locale}/tools/pdf/sign'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/sign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::submit
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:50
* @route '/{locale}/tools/pdf/sign'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::submit
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:50
* @route '/{locale}/tools/pdf/sign'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::submit
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:50
* @route '/{locale}/tools/pdf/sign'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::submit
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:50
* @route '/{locale}/tools/pdf/sign'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const sign = {
    pageCount: Object.assign(pageCount, pageCount),
    submit: Object.assign(submit, submit),
}

export default sign